<script>
export default {
  data: (vm) => ({
    errorMessages: [
      {
        email: "",
        cpf: "",
      },
    ],
    requiredRules: [
      (v) => {
        if (v) return true;
        const msg = vm.$t("errors.required");
        return msg;
      },
    ],
    emailRules: [
      (v) => {
        if (!!v && v.length > 0) return true;
        const msg = vm.$t("errors.required");
        return msg;
      },
      (v) => {
        if (
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          )
        )
          return true;
        const msg = "Email" + vm.$t("errors.invalid");
        return msg;
      },
    ],
    passwordRules: [
      (v) => {
        if (v) return true;
        const msg = vm.$t("errors.required");
        return msg;
      },
      (v) => {
        if (v.length > 5) return true;
        const msg = "Senha tem que ter pelo menos 6 caracteres";
        return msg;
      },
    ],
    cnpjRules: [
      (v) => {
        if (v) return true;
        const msg = vm.$t("errors.required");
        return msg;
      },
      (cnpj) => {
        if (cnpj && cnpj.length) {
          cnpj = cnpj.replace(/[^\d]+/g, "");

          if (cnpj.length !== 14) return "CNPJ" + vm.$t("errors.invalid");

          // Elimina CNPJs invalidos conhecidos
          if (
            cnpj === "00000000000000" ||
            cnpj === "11111111111111" ||
            cnpj === "22222222222222" ||
            cnpj === "33333333333333" ||
            cnpj === "44444444444444" ||
            cnpj === "55555555555555" ||
            cnpj === "66666666666666" ||
            cnpj === "77777777777777" ||
            cnpj === "88888888888888" ||
            cnpj === "99999999999999"
          )
            return "CNPJ" + vm.$t("errors.invalid");

          // Valida DVs
          let tamanho = cnpj.length - 2;
          let numeros = cnpj.substring(0, tamanho);
          let digitos = cnpj.substring(tamanho);
          let soma = 0;
          let pos = tamanho - 7;
          for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2) pos = 9;
          }
          let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
          if (parseInt(resultado) !== parseInt(digitos.charAt(0)))
            return "CNPJ" + vm.$t("errors.invalid");

          tamanho = tamanho + 1;
          numeros = cnpj.substring(0, tamanho);
          soma = 0;
          pos = tamanho - 7;
          for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2) pos = 9;
          }
          resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
          if (parseInt(resultado) !== parseInt(digitos.charAt(1)))
            return "CNPJ" + vm.$t("errors.invalid");

          return true;
        } else {
          return true;
        }
      },
    ],
    cpfRules: [
      (v) => {
        if (v) return true;
        const msg = vm.$t("errors.required");
        return msg;
      },
      (cpf) => {
        let numeros;
        let digitos;
        let soma;
        let i;
        let resultado;
        let digitosIguais;
        digitosIguais = 1;
        if (cpf && cpf.length) {
          cpf = cpf.replace(/-|\./g, "");
          if (cpf.length !== 0 && cpf.length < 11) {
            return "CPF" + vm.$t("errors.invalid");
          }
          for (i = 0; i < cpf.length - 1; i++) {
            if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
              digitosIguais = 0;
              break;
            }
          }
          if (!digitosIguais) {
            numeros = cpf.substring(0, 9);
            digitos = cpf.substring(9);
            soma = 0;
            for (i = 10; i > 1; i--) {
              soma += numeros.charAt(10 - i) * i;
            }
            resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
            if (resultado !== parseInt(digitos.charAt(0))) {
              return "CPF" + vm.$t("errors.invalid");
            }
            numeros = cpf.substring(0, 10);
            soma = 0;
            for (i = 11; i > 1; i--) {
              soma += numeros.charAt(11 - i) * i;
            }
            resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
            if (resultado !== parseInt(digitos.charAt(1))) {
              return "CPF" + vm.$t("errors.invalid");
            }
            return true;
          } else return "CPF" + vm.$t("errors.invalid");
        } else return true;
      },
    ],
    dateValidRules: [
      (v) => {
        let date = false;
        if (!!v && v.indexOf("/") === -1 && v.length === 8) {
          const day = v.substr(0, 2);
          const month = Number(v.substr(2, 2)) - 1;
          const year = v.substr(4, 8);
          date = [year, month, day];
        }

        return vm.$moment(date).isValid() || vm.$t("errors.invalidDate");
      },
    ],
    rulesValidation: {
      required: (value) => !!value || vm.$t("errors.required"),
      noSpecialChars: (value) => {
        const alphanumericRegex = /^[a-zA-Z0-9 À-ú]+$/;
        return (
          alphanumericRegex.test(value) ||
          "Apenas letras e números são permitidos"
        );
      },
      minChar: (value) =>
        (!!value && value.length >= 6) || vm.$t("errors.sixCharacters"),
      email: (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return (
          (!!value && pattern.test(value)) || "E-mail" + vm.$t("errors.invalid")
        );
      },
      dateValid: (value) => {
        if (!value) return true;

        if (typeof value !== "string" || value.length !== 10) {
          return "Data inválida.";
        }

        const parts = value.split("/");
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const year = parseInt(parts[2], 10);

        const date = new Date(year, month, day);
        if (
          isNaN(date.getTime()) ||
          date.getDate() !== day ||
          date.getMonth() !== month ||
          date.getFullYear() !== year ||
          date.getFullYear() > new Date().getFullYear() + 120 ||
          date.getFullYear() < new Date().getFullYear() - 120
        ) {
          return "Data inválida.";
        }

        return true;
      },
      ageThreshold: (value) => {
        const date = (value || "")
          .replace(/(\d{2})(\d{2})(\d{4})/, "$3,$2,$1")
          .split(",")
          .map((x, i) => (i === 1 ? Number(x) - 1 : x));
        const yearDifference = vm.$moment().year() - vm.$moment(date).year();
        return yearDifference <= 100 && yearDifference >= 15
          ? true
          : vm.$t("errors.invalidDate");
      },
    },
  }),
  methods: {
    validate(type) {
      return this.$refs[type].validate();
    },
    reset(type) {
      this.$refs[type].reset();
    },
    resetValidation(type) {
      this.$refs[type].resetValidation();
    },
  },
};
</script>
